import React from 'react';
import MetaTags from 'react-meta-tags'
import {
  Alert,
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  UncontrolledAlert,
  Container,
  Table,
  Label,
  Input,
} from "reactstrap"
import { Link, withRouter } from "react-router-dom"
import Breadcrumbs from './../../../../components/Common/Breadcrumb'
import AlertService from './../../../../Services/alertService'
import ReactPaginate from 'react-paginate'
import { useSelector } from 'react-redux';

const PaymentSystems = (props) => {

  const language = useSelector(state => state.Languages.language)

  const removePaymentSystem = (paymentSystem) => {
    AlertService.alertConfirm(
      `Are you sure you want to delete "${paymentSystem.name}" ?`, "", `yes`, 'no'
    ).then(() => {

    })
  }

  return <React.Fragment>
    <div className="page-content">
      <MetaTags>
        <title>Payment Systems</title>
      </MetaTags>
      <Container fluid={true}>
        <Breadcrumbs title="Payment Systems" breadcrumbItem="Payment Systems" />

        <div className='my-2'>
          <div className='d-flex justify-content-end'>
            <button className="btn btn-outline-primary" type="button" onClick={() => props.history.push(`/${language}/payment-system/form`)}>
              Create Payment System
            </button>
          </div>
        </div>
        <hr />
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <div className="table-responsive">
                  <Table className="table table align-middle table-nowrap table-hover">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Fee</th>
                        <th>Max Deposit</th>
                        <th>MinDeposit</th>
                        <th>Image</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className='cursor-default'>
                        <th>PayPal</th>
                        <td>0.8</td>
                        <td>3000 $</td>
                        <td>1 $</td>
                        <td>image todo</td>
                        <td>
                          <div className="d-flex gap-3">
                            <Link className="text-success" to="/payment-system/form/123">
                              <i className="mdi mdi-pencil font-size-18" id="edittooltip"></i>
                            </Link>
                            <Link className="text-danger" to="#">
                              <i className="mdi mdi-delete font-size-18" id="deletetooltip" onClick={removePaymentSystem}></i>
                            </Link>
                          </div>
                        </td>
                      </tr>
                      <tr className='cursor-default'>
                        <th>Stripe</th>
                        <td>1.2</td>
                        <td>5000 $</td>
                        <td>1 $</td>
                        <td>image todo</td>
                        <td>
                          <div className="d-flex gap-3">
                            <Link className="text-success" to="/payment-system/form/123">
                              <i className="mdi mdi-pencil font-size-18" id="edittooltip"></i>
                            </Link>
                            <Link className="text-danger" to="#">
                              <i className="mdi mdi-delete font-size-18" id="deletetooltip" onClick={removePaymentSystem}></i>
                            </Link>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Col>
          <div className="row mt-2">
            <Col className="col-12">
              <div>
                <ReactPaginate
                  nextLabel={"next"}
                  // onPageChange={this.handlePageClick}
                  pageRangeDisplayed={3}
                  marginPagesDisplayed={2}
                  pageCount={10}
                  previousLabel={"prev"}
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  containerClassName="pagination"
                  activeClassName="active"
                  renderOnZeroPageCount={null}
                  forcePage={0}
                />
              </div>
            </Col>
          </div>
        </Row>
      </Container>
    </div>
  </React.Fragment>
}

export default withRouter(PaymentSystems)
